"use strict";
var core_1 = require('@angular/core');
var moment = require('moment');
// under systemjs, moment is actually exported as the default export, so we account for that
var momentConstructor = moment.default || moment;
var UtcPipe = (function () {
    function UtcPipe() {
    }
    UtcPipe.prototype.transform = function (value) {
        return moment(value).utc();
    };
    UtcPipe.decorators = [
        { type: core_1.Pipe, args: [{ name: 'amUtc' },] },
    ];
    /** @nocollapse */
    UtcPipe.ctorParameters = [];
    return UtcPipe;
}());
exports.UtcPipe = UtcPipe;
//# sourceMappingURL=utc.pipe.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/~/angular2-moment/utc.pipe.js
// module id = ../../../../angular2-moment/utc.pipe.js
// module chunks = 7